// extracted by mini-css-extract-plugin
export default {"question":"Question_question__euKNK","line":"Question_line__fVoEH"};